import { useState } from "react";
import { Button } from "../../../components/button/button";
import { Header } from "../../../components/header/header";
import { ProfileInfo } from "../../../components/profileInfo/profileInfo";
import { ExpertsList } from "./expertsList";
import { usePopup } from "../../../components/popup/popup";

import styles from "./experts.module.css";
import { Image } from "../../../components/image/image";
import { ArrowIcon } from "../../../assets/icons";
import { openExternalLink } from "../../../utils/openExternalLink";

import { Text } from "../../../components/text/text";

export const ExpertsPage = () => {
    const [expertData, setExpertData] = useState(null);

    const [Popup, open] = usePopup();

    return (
        <>
            <Header title="Эксперты" />

            <div className={styles.experts}>
                {
                    ExpertsList.map(data => (
                        <Button
                            key={data.username}
                            text={<ProfileInfo name={data.name} photo={data.photo} />}
                            type="secondary"
                            onClick={() => {
                                setExpertData(data);
                                open();
                            }}
                            icon={<ArrowIcon />}
                        />
                    ))
                }
            </div>

            <Popup>
                <Image 
                    width="200px" 
                    height="200px" 
                    src={expertData?.photo} 
                    className={styles.expert_image}
                />

                <Text as="div" variant="body" className={styles.expert_name} size={24} weight={700}>{expertData?.name}</Text>
                <Text as="div" variant="body" className={styles.expert_description} size={16}>{expertData?.description}</Text>

                <Button
                    text="Перейти в чат"
                    onClick={() => {
                        openExternalLink(`https://t.me/${expertData?.username}`);
                    }}
                />
            </Popup>
        </>
    );
}